import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axios';

export const fetchDocuments = createAsyncThunk(
  'documents/fetchDocuments',
  async ({ proscai_id, page = 1, per_page = 9999 }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`api/v1/collections/tickets-excel/`, {
        params: {
          proscai_id,
          page,
          per_page,
        },
      });
      return response.data; // Guardar todo el objeto
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Error al obtener documentos');
    }
  }
);

const documentsSlice = createSlice({
  name: 'documents',
  initialState: {
    documents: [],
    count: 0,
    page: 1,
    per_page: 50,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.documents = action.payload.results;
        state.count = action.payload.count;
        state.page = action.payload.page;
        state.per_page = action.payload.per_page;
      })
      .addCase(fetchDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default documentsSlice.reducer;
